export function PolygonIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='33' height='32' viewBox='0 0 33 32' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M11.1667 6.66667L16.5 6M11.1667 25.3333L23.1667 24M6.5 20.6667V12M25.8333 19.3333L22.5 8.66667'
        stroke='currentColor'
        strokeLinecap='round'
        strokeDasharray='4 3'
      />
      <path
        d='M21.168 7.16699C22.5487 7.16699 23.668 6.0477 23.668 4.66699C23.668 3.28628 22.5487 2.16699 21.168 2.16699C19.7873 2.16699 18.668 3.28628 18.668 4.66699C18.668 6.0477 19.7873 7.16699 21.168 7.16699Z'
        stroke='currentColor'
      />
      <circle cx='27.832' cy='23.333' r='2.5' stroke='currentColor' />
      <circle cx='6.5' cy='26' r='2.5' stroke='currentColor' />
      <path
        d='M6.5 9.83301C7.88071 9.83301 9 8.71372 9 7.33301C9 5.9523 7.88071 4.83301 6.5 4.83301C5.11929 4.83301 4 5.9523 4 7.33301C4 8.71372 5.11929 9.83301 6.5 9.83301Z'
        stroke='currentColor'
      />
    </svg>
  )
}
